//请自行添加语言资源
const cscDashboard = {
  msg:{
  }
};
export default cscDashboard



// WEBPACK FOOTER //
// ./src/page/report/cscDashboard/lang/cscDashboard.zh.js